<template>
  <div>
    <div class="card">
      <div class="card-header membership-sales-table-header">
        <h4 class="card-header-title">
          <span style="margin-right: 2px;">
            <strong>{{ titleDate }}</strong> 회원권 매출 내역
          </span>

          <popover>
            결제일 기준 당월 회원권이 결제된 내역입니다. <br> 삭제된 회원권은 제외됩니다.
          </popover>

          <i
            class="vertical-rule"
            style="color: #f2f2f2; font-size: 16px; margin: 0 5px;"
          />

          <span class="total-count">
            총 <strong>{{ data.length }}</strong>건
          </span>
        </h4>

        <ul class="card-tab-menu responsive-visible desktop">
          <li
            v-for="menuOption in tabMenuOptions"
            :class="{'active': menuOption.value === curMenu}"
            @click="onSelectTab(menuOption.value)"
          >
            {{ menuOption.label }}
          </li>
        </ul>

        <el-select
          v-model="curMenu"
          class="card-tab-select-box responsive-visible mobile"
        >
          <el-option
            v-for="item in tabMenuOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>

      <el-table
        v-if="data.length"
        v-loading="loading"
        :data="data"
        class="fifl-table"
        style="height: 500px;"
        header-row-class-name="fifl-table-header-row"
        header-cell-class-name="fifl-table-header-cell"
        row-class-name="fifl-table-row"
        cell-class-name="fifl-table-cell"
        max-height="500"
        row-key="id"
        @filter-change="onTableFilterChange"
        @row-click="handleRowClick"
      >
        <el-table-column
          v-for="(columnOption, colIndex) in columnOptions"
          :key="colIndex"
          v-bind="columnOption.bindAttributes"
        >
          <template
            slot-scope="scope"
          >
            <template v-if="columnOption.isHtmlTemplate">
              <div v-html="columnOption.template(scope)" />
            </template>
            <template v-else>
              {{ columnOption.template ? columnOption.template(scope) : templateProp(columnOption, scope) }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <empty-table 
        v-else
        :props-loading-status="loading"
        :props-has-parent="emptyTableProps.hasParent"
        :props-is-icon="emptyTableProps.isIcon"
        :props-header-height="emptyTableProps.headerHeight"
        :props-data="emptyTableProps.data"
        :props-table-body-height="emptyTableProps.bodyHeight"
        :props-message="emptyMessage" 
      />
    </div>
  </div>
</template>

<script>
import EmptyTable from '@/components/EmptyTable';
import MembershipSalesTableColumnOptions from './MembershipSalesTableColumnOptions';
import dateFns from 'date-fns';
import Popover from '../../components/popover';

export default {
  name: 'MembershipSalesTable',
  components: { Popover, EmptyTable },
  props: {
    titleDate: {
      type: String
    },
    curDate: {
      type: Date
    }
  },
  watch: {
    curMenu: function() {
      //TODO : 실제로 데이터를 받아오는 타이밍과 일치시킵니다.
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 600);
    }
  },
  data() {
    return {
      curMenu: 'total',
      tabMenuOptions: [
        { label: '전체', value: 'total' },
        { label: '카드', value: 'card' },
        { label: '현금', value: 'cash' },
        { label: '미수금', value: 'remainder' }
      ],
      columnOptions: MembershipSalesTableColumnOptions,
      filters: {
        classification: []
      },
      loading: false,
      emptyTableProps: {
        bodyHeight: 500,
        headerHeight: 43,
        hasParent: true,
        isIcon: true,
        data: [
          { label: '이름', width: 110 + 'px' },
          { label: '구분', width: 70 + 'px' },
          { label: '결제 회원권', width: 'calc(100% - 740px)' },
          { label: '결제 금액', width: 100 + 'px' },
          { label: '카드', width: 100 + 'px' },
          { label: '현금', width: 100 + 'px' },
          { label: '미수금', width: 100 + 'px' },
          { label: '결제일', width: 100 + 'px' }
        ]
      }
    };
  },
  computed: {
    data() {
      const payments = this.$store.getters.getPayments(this.curMenu);
      if (this.filters.classification.length === 0) {
        return payments;
      }
      return payments.filter(payment =>
        this.filters.classification.includes(payment.classification.toString())
      );
    },
    emptyMessage() {
      if (
        dateFns.isWithinRange(
          this.curDate,
          new Date('2019-01-01'),
          dateFns.endOfMonth(new Date())
        )
      ) {
        return '매출 내역이 없습니다.';
      }
      return '집계 기간이 아닙니다.';
    }
  },
  methods: {
    templateProp(columnOption, scope) {
      return scope.row[columnOption.bindAttributes.prop];
    },
    onSelectTab(value) {
      this.curMenu = value;
    },
    onTableFilterChange(filters) {
      this.filters = filters;
    },
    handleRowClick(row, column, event) {
      if (!column.label) {
        return;
      }

      const isNewTab = event.shiftKey,
        memberId = row.enrollment;

      if (isNewTab) {
        const routeData = this.$router
          .resolve({ path: `/member/${memberId}` })
          .catch(() => {});
        return window.open(routeData.href, '_blank');
      }

      this.$router.push(`/member/${memberId}`).catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.lesson-participate-table {
  width: 100%;
  height: 625px;
}

.table-badge {
  padding: 3px 7px;
  line-height: 20px;
  border-radius: 31px;
  background-color: #4a4a4a;
  color: white;
  font-size: 11px;
  letter-spacing: -0.5px;

  &.reenlist {
    background-color: #d3d3d3;
  }
}

.dashkit .card-header.membership-sales-table-header {
  padding-top: 0;
  padding-bottom: 0;

  @media screen and (max-width: 768px) {
    padding-top: 17px;
    padding-bottom: 15px;
    padding-right: 26px;
  }

  .card-header-title {
    flex: auto;
  }

  .card-tab-menu {
    flex: initial;
  }

  .help-icon {
    vertical-align: top;
    width: 15px;
    margin-right: 15px;

    @media screen and (max-width: 768px) {
      margin: 0;
    }
  }

  .total-count {
    @media screen and (max-width: 768px) {
      display: block;
      margin-top: 5px;
      font-weight: normal;

      strong {
        font-weight: normal;
      }
    }
  }
}

ul.card-tab-menu {
  list-style: none;
  float: right;
  margin: 0;
  padding: 0;

  li {
    cursor: pointer;
    display: inline-block;
    padding: 0 3px;
    margin-left: 12px;
    line-height: 58px;

    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: -0.7px;
    color: #d3d3d3;

    &.active {
      color: #4a4a4a;
      border-bottom: 2px solid #4a4a4a;
    }
  }
}

.card-header > .card-tab-select-box {
  width: 70px;
  flex: initial;
  position: absolute;
  top: 5px;
  right: 10px;

  input {
    border: 0;
    padding-right: 25px;
    color: #494949;
  }
}
</style>
